<template>
    <div
        class="magazine-page magazine-full-page-cover"
        ref="fullpagecover"
        :style="heightStyleObject"
        :data-lowreslast="pageLastIn.lowres"
        :data-lowresfirst="pageIn.lowres">
        <div
            class="magazine-full-page-cover-preview no-thumbnail btn-missing-image remove-icon-margin"
            v-if="pageLastIn.thumb === null && pageIn.thumb === null"></div>

        <div
            class="magazine-full-page-cover-preview"
            v-else>
            <div class="last-page">
                <img :src="pageLastIn.thumb" />
            </div>
            <div class="first-page">
                <img :src="pageIn.thumb" />
            </div>
        </div>

        <div class="options">
            <h6 class="page-type">{{ $t('magazine.cover') }}</h6>

            <a
                class="magazine-full-page-cover-edit"
                v-bind:href="pageEditUrl"
                v-if="canEdit()"
                >Open</a
            >
            <a
                class="magazine-full-page-cover-show view"
                href="#"
                :data-lowres="page.lowres"
                :data-thumb="page.thumb"
                :data-order="page.order"
                :id="'page' + page.id"
                >{{ $t('common.view') }}</a
            >
            <a
                class="magazine-full-page-cover-status"
                v-if="page.status == 'green' && isAdmin"
                href="javascript:;"
                @click="onRelease()"
                >{{ $t('magazine.release') }}</a
            >
            <a
                class="magazine-full-page-cover-versions"
                v-if="(isAdmin || ischiefeditor) && page.status !== 'green'"
                href="javascript:;"
                @click="showVersionModal()"
                >{{ $t('magazine.versions') }}
            </a>
        </div>

        <div
            class="btn btn-success-icon btn-checked approved"
            v-if="page.status == 'green'"></div>

        <div
            class="btn btn-warning-icon btn-checked pending"
            v-if="page.status == 'yellow'"></div>

        <b-modal
            v-model="show_version_modal"
            :title="$t('magazine.versions_page', { page: page.order })"
            size="md"
            ok-only
            :ok-title="$t('common.close')"
            ok-variant="primary"
            modal-class="apprentice-default-modal">
            <v-server-table
                ref="table"
                :url="pageVersionsUrl"
                :columns="tableColumns"
                :options="tableOptions"
                name="magazine-full-cover-versions-table">
                <div
                    slot="user_id"
                    slot-scope="{ row }">
                    {{ row.user != null ? row.user.full_name : $t('magazine.unfamiliar') }}
                </div>

                <div
                    v-if="isAdmin"
                    slot="actions"
                    slot-scope="{ row }">
                    <b-button
                        class="btn-restore-magazine-version"
                        v-if="page.status != 'green'"
                        v-b-tooltip.hover
                        variant="primary-icon-only"
                        :title="$t('magazine.recover_version')"
                        @click="selectVersion(row.id)">
                        <i class="fas fa-hand-pointer fa-fw"></i>
                    </b-button>
                </div>
            </v-server-table>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'design-2021-magazine-full-cover-component',
    props: ['pageIn', 'pageLastIn', 'ischiefeditor', 'userId', 'magazine', 'version'],
    data() {
        return {
            isAdmin: AuthIsAdmin,
            show_version_modal: false,
            pageVersionsUrl:
                this.routes.baseUrl() + '/magazine/' + this.magazine.id + '/' + this.pageIn.id + '/versions',
            page: this.pageIn,
            pageLast: this.pageLastIn,
            pageEditUrl: this.routes.baseUrl() + '/magazine/page/edit/' + this.magazine.id + '/' + this.pageIn.id,
            leftright: this.pageIn.order % 2 == 0 ? 'left' : 'right',
            tableColumns: [],
            tableOptions: {
                headings: {
                    user_id: this.$t('magazine.saved_by'),
                    createdathuman: this.$t('magazine.date'),
                    actions: this.$t('magazine.recover'),
                },
                sortIcon: {
                    base: 'fad',
                    is: 'fa-sort',
                    up: 'fa-sort-up',
                    down: 'fa-sort-down',
                },
                sortable: [],
                saveState: true,
            },
            heightStyleObject: {},
        };
    },
    methods: {
        showVersionModal() {
            this.show_version_modal = true;
        },
        canEdit() {
            if (this.page.status == 'green') return false;
            if (this.page.status == 'yellow' && !this.ischiefeditor) return false;

            if (!this.ischiefeditor) {
                let userId = this.userId;
                let result = false;
                this.page.rights.forEach(function (right, key) {
                    if (right.user_id == userId) {
                        result = true;
                        return;
                    }
                });

                return result;
            }

            return true;
        },
        onRemove() {
            this.alert
                .confirm(this.$t('magazine.delete_page'), this.$t('magazine.are_you_sure_you_want_to_delete_this_page'))
                .then((confirm) => {
                    if (confirm) {
                        this.alert.saving();

                        this.axios.delete(this.routes.magazinePageDelete(this.pageIn.magazine_id, this.pageIn.id)).then(
                            (response) => {
                                this.alert.success();
                                window.location.href = this.routes.magazine(this.pageIn.magazine_id);
                            },
                            (error) => {
                                this.alert.ajaxError(error);
                            },
                        );
                    }
                });
        },
        selectVersion(version_id) {
            this.alert
                .confirm(
                    this.$t('magazine.reset_version'),
                    this.$t('magazine.are_you_sure_you_want_to_replace_the_page_with_a_old_version'),
                    this.$t('magazine.yes_replace'),
                )
                .then((confirm) => {
                    if (confirm) {
                        this.alert.saving();

                        var data = {
                            page_id: this.page.id,
                            version_id: version_id,
                        };

                        this.axios.post(this.routes.magazinePageRestore(this.pageIn.magazine_id), data).then(
                            (response) => {
                                this.alert.success();
                                window.location.href = this.pageEditUrl;
                            },
                            (error) => {
                                this.alert.ajaxError(error);
                            },
                        );
                    }
                });
        },
        onRelease() {
            this.alert
                .confirm(
                    this.$t('magazine.release_page'),
                    this.$t('magazine.are_you_sure_you_want_to_release_this_page'),
                    this.$t('magazine.yes_release'),
                )
                .then((confirm) => {
                    if (confirm) {
                        this.alert.saving();

                        var data = {
                            page_id: this.page.id,
                        };

                        this.axios.post(this.routes.magazinePageRelease(this.pageIn.magazine_id), data).then(
                            (response) => {
                                this.alert.success();
                                this.page.status = 'blue';
                            },
                            (error) => {
                                this.alert.ajaxError(error);
                            },
                        );
                    }
                });
        },

        onResize() {
            this.calculateHeight();
        },

        calculateHeight() {
            if (this.magazine && this.magazine.size) {
                const height = Math.ceil(
                    (this.$refs.fullpagecover.offsetWidth / 100) *
                        50 *
                        (this.magazine.size.height / this.magazine.size.width),
                );
                this.heightStyleObject = {
                    height: height + 'px',
                };
            }
        },
    },

    mounted() {
        this.calculateHeight();
        window.addEventListener('resize', this.onResize);
        this.tableColumns = this.isAdmin ? ['user_id', 'createdathuman', 'actions'] : ['user_id', 'createdathuman'];
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.onResize);
    },
};
</script>

<style scoped lang="scss">
.magazine-full-page-cover {
    position: relative;
    width: 100%;

    .approved,
    .pending {
        position: absolute;
        right: 15px;
        top: 15px;

        &:before {
            margin-right: 0;
        }
    }

    &:hover {
        .options {
            opacity: 1;
        }
    }
}

.magazine-full-page-cover-preview {
    border-radius: $border-radius-content;
    height: 100%;
    display: flex;

    .first-page,
    .last-page {
        width: 50%;
        height: 100%;

        img {
            width: 100%;
            max-width: 100%;
            height: inherit;
            object-position: center;
            object-fit: cover;
        }
    }

    .first-page {
        img {
            border-top-right-radius: $border-radius-content;
            border-bottom-right-radius: $border-radius-content;
        }
    }

    .last-page {
        img {
            border-top-left-radius: $border-radius-content;
            border-bottom-left-radius: $border-radius-content;
        }
    }

    &.no-thumbnail {
        background-color: $inverse-info; /*darken($secondary-background-color, 75%);*/
        color: $white;
        width: 100%;

        &:before {
            color: $white;
            opacity: 0.3;
            font-size: 11rem;
            margin-right: 0;
        }
    }
}

.options {
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    top: 0;
    opacity: 0;
    transition: opacity 3ms ease;
    background-color: $magazine-page-hover-color;
    border-radius: $border-radius-content;

    .page-type {
        color: $white;
        position: relative;
        top: map-get($grid-gutter-spacing, 'ten');
        white-space: nowrap;
        padding-bottom: map-get($grid-gutter-spacing, 'eight');
        border-bottom: 1px solid $border-color;
        font-size: 1.125rem;
    }

    a {
        color: $white;
        font-size: 1.125rem;
        line-height: 1.5;
        margin-bottom: map-get($grid-gutter-spacing, 'fifteen');

        &:first-of-type {
            margin-top: map-get($grid-gutter-spacing, 'fifteen');
        }

        &:hover {
            color: $primary;
            font-weight: $font-weight-bold;
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'sm')) {
    .magazine-full-page-cover-preview {
        &.no-thumbnail {
            &:before {
                font-size: 16rem;
            }
        }
    }

    .options {
        justify-content: flex-start;
    }
}
</style>
